import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Stack, Text, Flex, List, Link, ListItem } from '@chakra-ui/react';
import { Area, BB_MENU_IDS } from '@whitbread-eos/api';
import { LanguageSelectorSwitcher, Popover, Accordion } from '@whitbread-eos/atoms';
import { formatDataTestId, logout } from '@whitbread-eos/utils';
import NextLink from 'next/link';
import NavItem from '../../HeaderLeisure/NavItem';
import { boxStyles, linkStyles, listItemStyles, listStyles } from '../../HeaderLeisure/NavigationMenu/NavigationMenu.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function BBNavigationMenu(_ref) {
  var navigationLabels = _ref.navigationLabels,
    language = _ref.language,
    languageMenuLabels = _ref.languageMenuLabels,
    tickIcon = _ref.tickIcon,
    dataTestId = _ref.dataTestId,
    isLogoutButton = _ref.isLogoutButton;
  var navStyle = language === 'en' ? stackStyle : stackStyleDE;
  return _jsxs(Stack, _objectSpread(_objectSpread({
    as: "nav"
  }, navStyle), {}, {
    "data-testid": formatDataTestId(dataTestId, 'NavigationLinks'),
    children: [_jsx(Box, {
      "data-testid": formatDataTestId(dataTestId, 'LanguageSelectorWrapper'),
      children: _jsx(LanguageSelectorSwitcher, {
        currentLanguage: language,
        tickIcon: tickIcon,
        languagesList: languageMenuLabels,
        area: Area.BB
      })
    }), navigationLabels.map((navigationLabel, index) => {
      return _jsx(Box, _objectSpread(_objectSpread({}, boxStyles), {}, {
        "data-testid": formatDataTestId(dataTestId, navigationLabel.navTitle),
        children: _jsx(Popover, _objectSpread(_objectSpread({
          triggerItem: _jsx(Box, {
            className: navigationLabel.id === BB_MENU_IDS.COMPANY ? 'assist-no-show' : '',
            children: _jsx(NavItem, {
              title: navigationLabel.navTitle
            })
          })
        }, _objectSpread({}, noBoxShadowStyle)), {}, {
          children: navigationLabel.subNav && _jsx(Flex, {
            w: "17rem",
            children: renderSubNavItems(navigationLabel.subNav)
          })
        }))
      }), index);
    })]
  }));
  function renderListItem(isLogout, option, key, testId) {
    if (isLogout) {
      return _createElement(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
        key: key,
        "data-testid": formatDataTestId(dataTestId, "".concat(testId, "-").concat(option.title))
      }), _jsx(Link, {
        onClick: logout,
        children: _jsx(Text, _objectSpread(_objectSpread({}, linkStyles), {}, {
          children: option.title
        }))
      }));
    } else {
      var _option$url;
      return _createElement(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
        key: key,
        "data-testid": formatDataTestId(dataTestId, "".concat(testId, "-").concat(option.title))
      }), _jsx(NextLink, {
        href: (_option$url = option.url) !== null && _option$url !== void 0 ? _option$url : '/',
        passHref: true,
        legacyBehavior: true,
        children: _jsx(Text, _objectSpread(_objectSpread({}, linkStyles), {}, {
          children: option.title
        }))
      }));
    }
  }
  function renderSubNavItemMenu(list) {
    return list.map((option, index) => {
      return renderListItem(false, option, index, 'subNavListItem');
    });
  }
  function renderSubNavItems(list) {
    return list.map(item => {
      return _jsx(List, _objectSpread(_objectSpread({}, listStyles), {}, {
        children: item.navOptions.map((option, index) => {
          return !option.subMenuLinks ? renderListItem(isLogoutButton(option.title), option, index, 'listItem') : _jsx(Accordion, {
            "data-testid": formatDataTestId(dataTestId, "listItemWithMenu-".concat(option.title)),
            accordionItems: formatAccordionItemProps(option.title, renderSubNavItemMenu(option.subMenuLinks)),
            bgColor: "baseWhite",
            accordionOverwriteStyles: accordionOverwriteStyles
          });
        })
      }), item.title);
    });
  }
  function formatAccordionItemProps(title, content) {
    return [{
      title,
      content
    }];
  }
}
var accordionItemButtonStyle = {
  whiteSpace: 'nowrap',
  fontWeight: 'normal',
  padding: 0
};
var accordionItemTextStyle = {
  fontWeight: 'normal',
  mb: '2',
  mt: '1',
  lineHeight: '1',
  _hover: {
    textDecoration: 'underline'
  }
};
var accordionIconStyle = {
  position: 'absolute',
  right: '0.75rem',
  height: '0.5em',
  paddingRight: '0px',
  paddingLeft: '0px',
  fontSize: '3rem'
};
var accordionItemPanelStyle = {
  pl: 'lg',
  _last: {
    paddingBottom: '0px'
  }
};
var accordionItemStyle = {
  borderTopWidth: '0px',
  _last: {
    borderBottomWidth: '0px'
  }
};
var accordionOverwriteStyles = {
  button: accordionItemButtonStyle,
  text: accordionItemTextStyle,
  panel: accordionItemPanelStyle,
  item: accordionItemStyle,
  icon: accordionIconStyle
};
var stackStyle = {
  direction: 'row',
  spacing: {
    lg: 'xl',
    xl: '5xl'
  },
  justifyContent: 'flex-end'
};
var stackStyleDE = {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8
};
var noBoxShadowStyle = {
  _focus: {
    boxShadow: 'none'
  }
};